import React from "react";
import { Box, Menu, MenuItem } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import usePermissions from "../permissions/usePermissions";
import { NavigationEntry, NavigationEntryItem, navigationLinks, navigationSettingItems, nonAdminItems } from "./Navigation";
import { useTranslation } from "react-i18next";
import Stack from "@mui/material/Stack";
import NavigationLogo from "./NavigationLogo";
import TaxGuruIconButton from "../components/button/TaxGuruIconButton";
import useMenuAnchorState from "../components/hook/useMenuAnchorState";
import CollapsedItemsMenu from "./menu/CollapsedItemsMenu";
import NavigationMenuItem from "./menu/NavigationMenuItem";
import useIAmAccountant from "../modules/accountant/function/useIAmAccountant";
import { settingsSectionPermissions } from "../permissions/TaxGuruPermissionBuilder";

const NavigationMobileSmartButton = ({ item, onCloseNavMenu }: { item: NavigationEntry; onCloseNavMenu: () => void }) => {
    const { accountant } = useIAmAccountant();

    const navItem = item as NavigationEntryItem;
    if (navItem.link === navigationLinks.TAX_LICENCES_LINK && accountant?.licence?.id) {
        return (
            <NavigationMenuItem
                key={navItem.link}
                onOptionClick={onCloseNavMenu}
                item={{
                    ...navItem,
                    link: `${navigationLinks.TAX_LICENCES_LINK}/${accountant?.licence?.id}`,
                }}
            />
        );
    }
    return <NavigationMenuItem item={item} onOptionClick={onCloseNavMenu} />;
};

const NavigationMobile = () => {
    const { anchorEl: adminAnchorEl, onOpenMenu: onOpenAdminMenu, onCloseMenu: onCloseAdminMenu } = useMenuAnchorState();
    const { anchorEl: navAnchorEl, onOpenMenu: onOpenNavMenu, onCloseMenu: onCloseNavMenu, open: navMenuOpen } = useMenuAnchorState();

    const { hasAtLeastOnePermission } = usePermissions();
    const { t } = useTranslation();

    const onOptionClick = () => {
        onCloseNavMenu();
        onCloseAdminMenu();
    };

    return (
        <Stack direction="row" alignItems="center">
            <TaxGuruIconButton size="large" onClick={onOpenNavMenu} color="primary">
                <MenuIcon />
            </TaxGuruIconButton>
            <NavigationLogo height="20px" />
            <Menu
                id="taxGuruMobileMenu"
                anchorEl={navAnchorEl}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                open={navMenuOpen}
                onClose={onCloseNavMenu}
                sx={{
                    display: { xs: "block", lg: "none" },
                }}
            >
                {nonAdminItems.map((item, index) => (
                    <NavigationMobileSmartButton onCloseNavMenu={onCloseNavMenu} key={index} item={item} />
                ))}
                {hasAtLeastOnePermission(settingsSectionPermissions) && (
                    <Box>
                        <MenuItem onClick={onOpenAdminMenu}>
                            {t("navigation.settings")}
                            <KeyboardArrowDownIcon />
                        </MenuItem>
                        <CollapsedItemsMenu
                            items={navigationSettingItems}
                            anchorEl={adminAnchorEl}
                            onOptionClick={onOptionClick}
                            onCloseMenu={onCloseAdminMenu}
                        />
                    </Box>
                )}
            </Menu>
        </Stack>
    );
};

export default NavigationMobile;
